import { createStyles, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { layoutContentMaxWidthPx } from '../../../shared/style-settings'

export const useCheckoutPaymentCompletedStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      maxWidth: layoutContentMaxWidthPx,
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(6),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      boxSizing: 'border-box',
    },
    /** Layout only; radius / shadow / paper from theme `MuiCard`. */
    cardMaxWidth: {
      width: '100%',
      maxWidth: theme.spacing(70),
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    /** Larger padding on this screen only; other CardContent chrome stays default. */
    cardContentPadding: {
      padding: theme.spacing(5, 4),
      '&:last-child': {
        paddingBottom: theme.spacing(5),
      },
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(6, 5),
        '&:last-child': {
          paddingBottom: theme.spacing(6),
        },
      },
    },
    /** Flex column scaffold inside the card. */
    contentStack: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    },
    headline: {
      textAlign: 'center',
      fontWeight: 700,
      fontSize: '1.75rem',
      lineHeight: 1.25,
      letterSpacing: '-0.02em',
      color: theme.palette.text.primary,
      marginBottom: theme.spacing(1),
      maxWidth: '100%',
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.5rem',
      },
    },
    subtitle: {
      textAlign: 'center',
      marginBottom: theme.spacing(3),
      maxWidth: theme.spacing(45),
      color: theme.palette.text.secondary,
      fontWeight: 500,
      lineHeight: 1.5,
    },
    illustration: {
      display: 'block',
      width: '100%',
      maxWidth: theme.spacing(48),
      height: 'auto',
      marginBottom: theme.spacing(4),
    },
    actionsColumn: {
      alignSelf: 'stretch',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1.5),
      marginTop: theme.spacing(0.5),
    },
    primaryRow: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: theme.spacing(1.5),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        gridTemplateColumns: '1fr 1fr',
      },
    },
    /** Width hints for the two-column row only; look & feel from theme `MuiButton`. */
    primaryRowButtonLayout: {
      flex: '1 1 auto',
      minWidth: theme.spacing(18),
      maxWidth: theme.spacing(32),
    },
  })
)
